import { Element, FormulaElement } from "../types";

export const isFormulaElement = (element: Element): element is FormulaElement =>
  element.kind === "formula";
